import { Middleware } from 'redux'
import _ from 'lodash'
import { FormDispatch, FormRootState } from './formStore'
import { ConceptStatusValueType, MaterialArea, MaterialStatusQuery } from '@fusion-advantage/backcompat'
import { AsyncResultHashConcept, formShouldQueryMaterialStatus, LabActionType } from '@fusion-advantage/formlib'
import { useFormAppRelay } from '../lib/relay/FormAppRelay'
import { MaterialStateStatus, setAsyncResultMaterialStatus } from './asyncResultSlice'
import { submitStatusUpdates } from './submitStatusUpdates'
import { Md5 as md5 } from 'ts-md5'

export const asyncResultMw: Middleware<{}, FormRootState> = store => {
	const dispatch = store.dispatch as FormDispatch
	return next => action => {
		const formAppRelay = useFormAppRelay()
		const prevState = store.getState()
		const result = next(action)
		const nextState = store.getState()

		// submitting this hash on any async result change is a hack to allow
		// calc3 calculations to pick up when any of these values have changed.
		// md5'ing the whole thing is probably not all that necessary,
		// but it works for now, and maybe later we'll come up with some
		// creative way to allow a selector input on a calculation anyway...
		if(prevState.asyncResult !== nextState.asyncResult) {
			dispatch(submitStatusUpdates([{
				cid: AsyncResultHashConcept.cid,
				value: md5.hashStr(JSON.stringify(nextState.asyncResult)),
				valueType: ConceptStatusValueType.Derived,
			}]))
		}
		
		// update material statuses
		const codeNext = nextState.render.form?.export?.Form.Encounter.CodeNext
		if(formShouldQueryMaterialStatus(codeNext)) {
			nextState.labs.models.forEach((nextLab, idx) => {
				if(nextLab !== prevState.labs.models[idx]) {
					if(nextLab.action?.type !== LabActionType.Codes) {
						return
					}
					const query: MaterialStatusQuery = {
						area: MaterialArea.Labs,
						id: nextLab.action.code,
						type: nextLab.labname,
					}
					dispatch(setAsyncResultMaterialStatus({
						query,
						status: MaterialStateStatus.QueryPending,
					}))
					formAppRelay.queryMaterialStatus({query}).then(({status}) => {
						// if the lab in state is no longer the same,
						// ignore the update, because we've got another one
						// coming, or one that already came
						const nowLab = store.getState().labs.models[idx]
						if(nowLab !== nextLab) {
							return
						}
						dispatch(setAsyncResultMaterialStatus({query, status}))
					})
				}
			})
		}

		return result
	}
}
